const PERFORMANCE_PAGE = {
  title: 'Desempenho',
  general: 'Geral',
  turbo: 'Turbo',
  kpis: {
    availabilityRate: {
      title: 'Taxa de Disponibilidade',
      description:
        'Percentual do seu horário de funcionamento cadastrado na plataforma em que sua loja de fato ficou aberta, durante a semana selecionada (sempre de segunda à domingo)',
    },
    fillRate: {
      title: 'Taxa de aceitação',
      description:
        'Percentual de pedidos aceitos e válidos - status de sucesso ou em andamento - sobre o total de pedidos recebidos durante a semana selecionada',
    },
    orderRating: {
      title: 'Avaliação',
      description:
        'Média das avaliações dos clientes sobre os pedidos realizados durante a semana selecionada',
    },
    promoSellerActivationRate: {
      title: '% Ativação Turbine',
      description:
        'Percentual de produtos com desconto ativo em campanhas Turbine seu produto com base nas regras do programa.',
    },
    tenMinutesDeliveryReleaseRate: {
      title: 'Liberação em 10min',
      description:
        'Percentual dos pedidos colocados no aplicativo do entregador em até 10min',
      goal: '90%',
      videoId: 'Z_f3f8g9RuA',
    },
    fiveMinutesDeliveryReleaseRate: {
      title: 'Liberação em 5min',
      description:
        'Percentual dos pedidos colocados no aplicativo do entregador em até 5min',
    },
    deliveryTrackingAccuracyRate: {
      title: 'Taxa de rastreio',
      description:
        'Percentual de pedidos que foram corretamente rastreados com o aplicativo Zé Entregador durante a semana selecionada',
    },
    validOrders: {
      title: 'Total de pedidos',
      description:
        'Número total de pedidos válidos - status de sucesso ou em andamento - durante a semana selecionada',
    },
    thirtyFiveMinutesDeliveryAccurateRate: {
      title: 'Entregas em até 35 min',
      description:
        'Percentual de pedidos entregues em até 35 minutos. - Este indicador mede a alocação de recursos por demanda feita pelo PDV, não implicando pedir que os entregadores ultrapassem a velocidade permitida das vias',
    },
    fifteenMinutesDeliveryAccurateRate: {
      title: 'Entregas em até 15 min',
      description:
        'Percentual de pedidos entregues em até 15 minutos. Este indicador mede a alocação de recursos por demanda feita pelo Ponto de Venda, não implicando pedir que os entregadores ultrapassem a velocidade limite permitida',
    },
    idealPortfolioRate: {
      title: 'Portfólio ideal acumulado',
      description:
        'Média do percentual dos produtos do portfólio ideal ativos na sua plataforma durante a semana selecionada',
    },
    deliveryOrderAggroupmentRate3More: {
      title: 'Agrupamento de 3 ou mais pedidos',
      description:
        'Percentual de rotas iniciadas e finalizadas com 3 ou mais pedidos distintos agrupados com a mesma pessoa entregadora na semana selecionada. - Atenção, quanto menor essa taxa, melhor para sua operação e para indicadores como taxa de liberação em 10 min, entrega em até 35 min e avaliação do cliente.',
    },
  },
  performancePanel: {
    ordersAverageEvaluation: 'Avaliação média dos pedidos',
    ordersAverageAcceptance: 'Aceitação média de pedidos',
    top20BestSellers: 'Top 20 mais vendidos',
    totalValueToBeRefunded: 'Valor total a ser restituído',
  },
  negotiationPanel: {
    title: 'Negotiation',
    markup: 'Markup',
    operationalIncentive: 'Incentivo operacional',
    fareToEachDelivery: 'Frete para cada entrega',
  },
  orderBalancePanel: {
    title: 'Saldo de pedidos',
    periodTotalOrders: 'Total de pedidos no período',
  },
  totalsPanel: {
    orders: 'Pedidos',
    incentives: 'Incentivos',
    fare: 'Frete',
    coupons: 'Cupons',
    others: 'Outros',
    total: 'Total',
  },
  aboveTarget: 'acima da meta',
  aboveTargetOldKpi: 'Acima da meta',
  belowTarget: 'abaixo da meta',
  belowTargetOldKpi: 'Abaixo da meta',
  belowNextTarget: 'até a próxima meta',
  congratsInfo: 'Eba! Você atingiu todas as metas',
  details: 'Detalhes',
  filterByDateLabel: 'Filtrar por data:',
  lastUpdateLabel: 'Última atualização:',
  lastUpdateFallback:
    'Não foi possível carregar a última atualização. Recarregue a página ou tente novamente mais tarde.',
  update: 'Atualização:',
  selectWeek: 'Selecione a semana',
  invalidWeek: 'Semana selecionada não pode ser maior do que a atual',
  errorMessage: 'Opa, algo deu errado em nosso sistema!',
  tryAgain: 'Atualizar',
  seeDetails: 'Ver detalhes',
  tenMinutesReleaseVideo: 'Saiba mais sobre a liberação em 10 minutos',
}

export default PERFORMANCE_PAGE
